var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof v_my_profile !== "undefined") return resolve();
	__webpack_require__.l("https://my-profile.dev.tbconline.app/static/remoteEntry.js", function(event) {
		if(typeof v_my_profile !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		__webpack_error__.event = event;
		reject(__webpack_error__);
	}, "v_my_profile");
}).then(function() { return v_my_profile; });